var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('Navbar'),_c('Banner'),_c('Feature'),_c('Service'),_c('Awards'),_c('Video'),_c('Testimoni'),_c('Faq'),_c('Link'),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }